import { PayloadAction } from "app/core/models/action";
import { GeneralSettings } from '../../models/generic.model';

export const GET_GENERAL_SETTINGS = "[APP] GET_GENERAL_SETTINGS";
export const GET_GENERAL_SETTINGS_SUCCESS = "[APP] GET_GENERAL_SETTINGS_SUCCESS";

export class GetGeneralSettings implements PayloadAction {
    readonly type = GET_GENERAL_SETTINGS;
    constructor() { }
}
export class GetGeneralSettingsSuccess implements PayloadAction {
    readonly type = GET_GENERAL_SETTINGS_SUCCESS;
    constructor(public payload: GeneralSettings) { }
}

// Get Country List
export const PUSH_AVAILABLE_CONFIGURATION = 'PUSH_AVAILABLE_CONFIGURATION';
export class PushAvailableConfiguration implements PayloadAction {
    readonly type = PUSH_AVAILABLE_CONFIGURATION;
    constructor(public payload?) { }
}

export type GeneralActions =
    | GetGeneralSettings
    | GetGeneralSettingsSuccess
    | PushAvailableConfiguration;